class Track {
    constructor(options = {}, objInit){
        this.options = Object.assign(
            {},
            {    
                checkout : false,
                clientId: "67c33a3bdf668b34c7075a7e",
                cookiesVersion: "shopify-cookie-config",
                gtmID: "GTM-PRLFZLNW",  
                envWork : 'production', 
                language : 'fr',
                userAuthenticated : '0',
                userId : '',
                pageName : '',
                pageCategory : '',
                pageUrl : '',
                referenceGamme: '',
                currency: "EUR",
                state : false
            }, 
            options 
        );  

        this.objInit = objInit; 

        window.consentModeV2 = "";
        window.axeptioCookies = "";

        window.dataLayer = window.dataLayer || []; 
        window.gtag = function(){dataLayer.push(arguments)}; 

        window.gtag('consent', 'default', {
            analytics_storage: 'denied',
            ad_storage: 'denied',
            ad_user_data: 'denied',
            ad_personalization: 'denied',
            wait_for_update: 500  
        }); 

        window.axeptioSettings = {
            clientId: this.options.clientId,
            cookiesVersion: this.options.cookiesVersion,
            googleConsentMode: {
                default: {
                    analytics_storage: 'denied',
                    ad_storage: 'denied',
                    ad_user_data: 'denied',
                    ad_personalization: 'denied',
                    wait_for_update: 500 
                } 
            }
        }; 

        this.header = document.querySelector("#header");
        this.body = document.querySelector("body");
        
        this.checkoutState = false;

        if(typeof window.Shopify.Checkout != undefined){
            this.checkoutState = true;
        }
        
        if(!this.checkoutState){
            window.Shopify.loadFeatures([
                {
                name: "consent-tracking-api",
                version: "0.1",
                },
            ]); 
        } 

        //INIT 
        this.initRgpd(); 
    } 
 
    deleteCookie(name){ 
        document.cookie = name + "= ; expires = Thu, 01 Jan 1970 00:00:00 GMT; path=/";
    }  
    
    getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }
    
    setCookie(name,value,days) {
        var expires = "";
        if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days*24*60*60*1000));
          expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }

    closeCart(){
        this.header.classList.toggle('cart-open');  
        this.body.classList.toggle('freeze');
        document.querySelector("html").classList.toggle('freeze'); 
    } 
    
 
    loadGTM(id, checkout = false){
        if(!this.options.checkout){
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({"gtm.start":
            new Date().getTime(),event:"gtm.js"});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!="dataLayer"?"&l="+l:"";j.async=true;j.src=
            "https://www.googletagmanager.com/gtm.js?id="+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,"script","dataLayer",id); 
        }   
        if(checkout){
            window.gtag('consent', 'update', {
                'ad_storage': window.axeptioCookies.ad_storage,
                'ad_user_data': window.axeptioCookies.ad_user_data,
                'ad_personalization': window.axeptioCookies.ad_personalization,
                'analytics_storage': window.axeptioCookies.analytics_storage
            });
        }else{
            window.gtag('consent', 'update', {
                'ad_storage': window.consentModeV2.ad_storage,
                'ad_user_data': window.consentModeV2.ad_user_data,
                'ad_personalization': window.consentModeV2.ad_personalization,
                'analytics_storage': window.consentModeV2.analytics_storage
            });
        }
        if(this.objInit != "" && typeof this.objInit != "undefined" && typeof this.objInit == "object"){
            this.push(this.objInit); 
        }
    } 

    async push(obj, cb){ 
        var dataInit = {
            'currency' : this.options.currency, 
            'pageLang' : this.options.pageLang, 
            'UserAuthenticated' : this.options.userAuthenticated, 
            'UserId' : this.options.userId, 
            'PageName' : this.options.pageName, 
            'pageUrl' : this.options.pageUrl 
        };
        var dataMerge = {...dataInit, ...obj};  
        window.dataLayer.push(dataMerge);   

        if(typeof cb != "undefined" && typeof cb == "function"){
            cb(); 
        }
    }

    initRgpd() {  
 
        //Chargement script Axeptio  
        /*
        var t = document.getElementsByTagName("script")[0], e = document.createElement("script");
        e.async = true; e.src = "//static.axept.io/sdk.js";
        t.parentNode.insertBefore(e, t);  
        */

        //Check du save
        void 0 === window._axcb && (window._axcb = []);
        //https://developers.google.com/tag-platform/security/guides/consent?hl=fr&consentmode=advanced 

        //Test des cookies axeptio 
        if(this.getCookie("axeptio_cookies") != null){ 
            window.axeptioCookies = JSON.parse(decodeURIComponent(this.getCookie("axeptio_cookies"))).$$googleConsentMode; 
        } 

        //Mise à jour consentement
        window._axcb.push((axeptio) => {  
            if(axeptio.userPreferencesManager.choices.$$completed){
                if(document.querySelector("#axeptio_overlay") != null){
                    document.querySelector("#axeptio_overlay").style.display = "none";  
                }
                window.consentModeV2 = axeptio.userPreferencesManager.choices.$$googleConsentMode;  
            } 
            axeptio.on("consent:saved", function(rep) {  
                if(document.querySelector("#axeptio_overlay") != null){
                    document.querySelector("#axeptio_overlay").style.display = "none";   
                }  
            });
            // a corriger
            // afficher le retour axeptio dans le checkout
            if(!this.options.checkout){
                this.loadGTM(this.options.gtmID); 
            }
        }); 

        if(this.options.checkout){
            this.loadGTM(this.options.gtmID);    
            // a verfier
        } 

        if(!this.checkoutState){
            window.Shopify.customerPrivacy.setTrackingConsent(
                {
                    preferences: true,
                    analytics: true,
                    marketing: true,
                    sale_of_data: true
                }, 
                () => {}
            );  
        }
 
    }  
}